import React from 'react';
import {
  CRow,
  CCol,
  CCard,
  CCardBody,
  CCardTitle,
  CBadge,
  CImage,
} from '@coreui/react';
import { useState } from 'react';
import resolveImage from '../../../store/ResolveImage';
import { API_URL } from '../../../../constants';
import { useNavigate, Link } from 'react-router-dom';
import { formatDate } from '../../../../utils/formatDate';
import { withRouter } from '../../../../withRouter';
import actions from '../../../../actions';
import { connect } from 'react-redux';
import ManagerPagination from '../../Pagination';
import LoadingIndicator from '../../../store/LoadingIndicator';
import Input from '../../../Common/HtmlTags/Input';
import { GoBack } from '../../../../containers/goBack/inedx';
import { getCartPriceSummary } from '../../../store/CartSummary';

const EventOrderList = (props) => {
  const { isLightMode, orderIsLoading, orders = [], eventOrderGroup } = props;
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const ordersPerPage = 10;
  const filteredOrders = orders.filter(order =>
    (order._id || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredOrders.length / ordersPerPage);
  const startIndex = (currentPage - 1) * ordersPerPage;
  const endIndex = startIndex + ordersPerPage;
  const currentOrders = filteredOrders.slice(startIndex, endIndex);
  const navigate = useNavigate();
  const groupName = eventOrderGroup?.eventName || 'Event orders';
  const groupImage = eventOrderGroup?.imageUrl || '';

  const handleSearch = (name, value) => {
    setSearchTerm(value);
    setCurrentPage(1);
  };

  return (
    <div data-aos="fade-up" className='container-lg px-4 d-flex flex-column mb-custom-5em'>
      {orderIsLoading && <LoadingIndicator />}
        <div className='d-flex justify-content-between'>
        <h2 style={{ margin: 0 }} className={`${isLightMode ? 'p-black': 'p-white'}`}>{groupName}</h2>
        <div className='align-self-end'>
          <GoBack navigate={navigate} text={"go back"} />
        </div>
        </div>
        <hr className={`${isLightMode ? 'p-black': 'p-white'}`} style={{ margin: '.5em' }}></hr>
        <h2 className={`${isLightMode ? 'p-black': 'p-white'} font-size-20`}>{filteredOrders.length} Orders</h2>
        {eventOrderGroup && !eventOrderGroup.eventExists && (
          <p className={`${isLightMode ? 'p-black': 'p-white'}`}>Event removed. Order history kept.</p>
        )}

      <div className="mb-4">
        <Input
          type="search"
          placeholder="Search orders by id..."
          name="searchOrders"
          value={searchTerm}
          onInputChange={handleSearch}
        />
      </div>

      <CRow className='gy-4'>
      {currentOrders.map((order, idx) => {
        const { total } = getCartPriceSummary(order?.cart?.tickets, order?.cart?.products);
        const hasProducts = order?.products?.length > 0
        const productFirstImage = order?.products?.[0]?.imageUrls?.[0] || '';
        const eventImage = order?.events?.[0]?.imageUrls?.[0] || groupImage;
        return (
       <CCol md={6} key={order._id || idx}>
        <Link to={`/dashboard/order/${order._id}`}>
      <CCard className={`${isLightMode ? 'bg-white p-black' : 'bg-black p-white border'} flex-row overflow-hidden`}>
      <div style={{ width: '40%' }}>
        <CImage
          src={hasProducts && !eventImage ? resolveImage(API_URL + productFirstImage || '') : resolveImage(API_URL + eventImage || '')}
          alt='Order Event'
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      </div>
      <CCardBody>
        <CCardTitle className='mb-2'>
          <strong>Order:</strong> #{order._id || 'N/A'}
        </CCardTitle>

        <CBadge color={order.paymentStatus === 'success' ? 'success' : 'danger'} className='mb-2'>
          {order.paymentStatus || order?.status === 'false' && "There's an issue with this payment"}
        </CBadge>
        <CRow>
          <CCol className='mb-2'>
            <strong>Email:</strong> {order.billingEmail || 'N/A'}
          </CCol>
        </CRow>

        <CRow className='mb-2'>
          <CCol>
            <strong>Method:</strong> {order.paymentMethod || 'N/A'}
          </CCol>
          <CCol className='text-end'>
            <strong>Date:</strong> {formatDate(order.createdAt)}
          </CCol>
        </CRow>

        <CRow className='mb-2'>
          <CCol>
            <strong>Ordered By:</strong> {order.user ? 'User' : 'Guest'}
          </CCol>
          <CCol className='text-end'>
            {order.guest?.name ? <><strong>Guest Name:</strong> {order.guest.name}</> : <><strong>User name: {order.user.name}</strong></>}
          </CCol>
        </CRow>
          <div className='mt-2'>
            <CRow>
              <CCol><strong>Total:</strong></CCol>
              <CCol className={`text-end fw-bold ${order.paymentStatus === 'success' ? 'text-success' : 'text-danger'}`}>₦{total}</CCol>
            </CRow>
          </div>
      </CCardBody>
    </CCard>
  </Link>
  </CCol>
)})}
      </CRow>
        <ManagerPagination
          isLightMode={isLightMode}
          data={filteredOrders}
          totalPages={totalPages}
          startIndex={startIndex}
          endIndex={endIndex}
          onPageChange={setCurrentPage}
        />
    </div>
  );
};

class EventOrders extends React.PureComponent {
  componentDidMount () {
    const eventKey = this.props.match.params.eventKey;
    this.props.fetchEventOrders(eventKey);
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.eventKey !== prevProps.match.params.eventKey) {
      this.props.fetchEventOrders(this.props.match.params.eventKey);
    }
  }

  render () {
    return (
      <EventOrderList {...this.props} />
    );
  }
}

const mapStateToProps = state => ({
  orders: state.order.eventOrders,
  eventOrderGroup: state.order.eventOrderGroup,
  orderIsLoading: state.order.isLoading
});

export default connect(mapStateToProps, actions)(withRouter(EventOrders));
